import type { MailboxKey } from "owa-client-types";
import type { MailboxGroup } from "owa-mail-list-store";
import doesTableSupportUndo from "./doesTableSupportUndo";

/**
 * Returns true if every per-mailbox group is individually undo-eligible.
 * @param groups - A map of mailbox keys to their corresponding mailbox groups.
 * @param getSourceFolderId - A function that resolves the source folder ID for a given mailbox group.
 * @param getDestinationFolderId - An optional function that resolves the destination folder ID for a given mailbox group.
 * @returns true if all groups support undo, false otherwise.
 */
export default function doesMultiMailboxTriageSupportUndo(groups: Map<MailboxKey, MailboxGroup>, getSourceFolderId: (group: MailboxGroup) => string | undefined, getDestinationFolderId?: (group: MailboxGroup) => string | undefined): boolean {
    if (groups.size === 0) {
        return false;
    }
    for (const group of groups.values()) {
        if (!doesTableSupportUndo(getSourceFolderId(group), group.mailboxInfo, getDestinationFolderId?.(group))) {
            return false;
        }
    }
    return true;
}
